import LogoPasmik from 'assets/icons/PasarMIKRO-Primary-Logogram-3.svg'
import BcaLogo from 'assets/images/BCA-01.png'
import BriLogo from 'assets/images/BRI-01.png'
import axios from 'axios'
import CustomButton from 'components/Buttons/CustomButton'
import PMBModalRemove from 'components/PMBModalRemove'
import { TableComponent as DataTable } from 'components/TableComponent'
import { apiEndpoint } from 'configs'
import { useCallback, useEffect, useState } from 'react'
import {
  AlertCircle,
  ChevronRight,
  Trash2,
  Eye,
} from 'react-feather'
import {
  useFetchPendingBcaAllQuery,
  useCancelBcaUniqueCodeByIdMutation,
} from 'features/private-views/topup/topupApiSlice'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, Container, Modal, ModalBody, Spinner } from 'reactstrap'

const normalizePendingList = (payload) => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data)) return payload.data
  if (Array.isArray(payload?.items)) return payload.items
  if (Array.isArray(payload?.data?.items)) return payload.data.items
  return []
}

const OneLinkTopup = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const dataState = location.state
  const [topupMethod, setTopupMethod] = useState('')
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [tfMethod, setTfMethod] = useState('')
  const [disbBanks, setDisbBanks] = useState([])
  const [loading, setLoading] = useState(false)
  const [dataUser, setDataUser] = useState(null)
  const displayAmount = dataState?.amount || dataUser?.amount
  const [isClick, setIsClick] = useState(false)
  const [banks, setBanks] = useState([])
  const [errMsg, setErrMsg] = useState('')
  const [token, setToken] = useState(null)
  const [pendingBcaPublicList, setPendingBcaPublicList] = useState([])
  const [loadingPendingBcaPublic, setLoadingPendingBcaPublic] = useState(false)
  const publicVersion = useSelector((s) => s.publicVersion)
  const auth = useSelector((s) => s.auth)
  const queryParams = new URLSearchParams(location.search)
  const shouldShowPendingList =
    queryParams.get('havePendingTopupUniqueCode') === '1'

  const {
    data: pendingBcaAllData,
    isFetching: loadingPendingBcaAll,
    refetch: refetchPendingBcaAll,
  } = useFetchPendingBcaAllQuery(undefined, { skip: !auth?.token })
  const pendingBcaList = Array.isArray(pendingBcaAllData)
    ? pendingBcaAllData
    : pendingBcaAllData?.data || pendingBcaAllData?.items || []
  const pendingBcaRows =
    pendingBcaList?.length > 0 ? pendingBcaList : pendingBcaPublicList

  const isBcaLocked =
    dataState?.havePendingTopupUniqueCode ||
    shouldShowPendingList ||
    pendingBcaRows?.length > 0

  const [cancelBcaUniqueCodeById] = useCancelBcaUniqueCodeByIdMutation()
  const [selectedPendingBca, setSelectedPendingBca] = useState(null)
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
  const [selectedCancelId, setSelectedCancelId] = useState(null)

  const handleCancelTopup = async (id) => {
    try {
      setLoading(true)
      if (auth?.token) {
        await cancelBcaUniqueCodeById({ topupuniquecodeId: id }).unwrap()
      } else {
        await axios.post(
          `${apiEndpoint}/api/v1/bussines/topupuniquecode/cancelbyid`,
          { topupuniquecodeId: id },
          {
            headers: {
              OnepaymentKey: `${token}`,
            },
          },
        )
      }
      if (auth?.token) {
        refetchPendingBcaAll()
      }
      fetchPendingBcaPublic()
      setIsCancelModalOpen(false)
      setSelectedCancelId(null)
    } catch (err) {
      setErrMsg(err?.response?.data?.message ?? err.message)
    } finally {
      setLoading(false)
    }
  }

  const fetchPendingBcaPublic = useCallback(async () => {
    if (!token || !shouldShowPendingList) return

    try {
      setLoadingPendingBcaPublic(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/topupuniquecode/pending/all`,
        {
          params: {
            onepaymentkey: token,
          },
          headers: {
            OnepaymentKey: `${token}`,
          },
        },
      )
      setPendingBcaPublicList(normalizePendingList(data))
    } catch {
      try {
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/bussines/topupuniquecode/pending/all`,
          {
            params: {
              onepaymentkey: token,
            },
            headers: {
              OnepaymentKey: `${token}`,
            },
          },
        )
        setPendingBcaPublicList(normalizePendingList(data))
      } catch (fallbackError) {
        setErrMsg(
          fallbackError?.response?.data?.message ?? fallbackError.message,
        )
      }
    } finally {
      setLoadingPendingBcaPublic(false)
    }
  }, [shouldShowPendingList, token])

  const pendingBcaColumns = [
    {
      name: 'Batas Waktu',
      selector: (row) => row.expiredDate,
      minWidth: '150px',
      cell: (row) => (
        <div>
          {row?.expiredDate
            ? new Date(row.expiredDate).toLocaleString('id-ID', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })
            : '-'}
        </div>
      ),
    },
    {
      name: 'Metode',
      selector: (row) => row.bankCodeReceiver,
      minWidth: '150px',
      cell: (row) => (
        <div className="fw-bold text-dark">
          {row.bankCodeReceiver === 'BCA'
            ? 'Transfer BCA'
            : `Transfer ${row.bankCodeReceiver}`}
        </div>
      ),
    },
    {
      name: 'Jumlah',
      selector: (row) => row.amountPlusUniqueCode,
      minWidth: '150px',
      cell: (row) => (
        <div className="fw-bold text-dark">
          Rp
          {intl.formatNumber(
            Number(row?.amountPlusUniqueCode || row?.amount || 0),
            { useGrouping: 'always' },
          )}
        </div>
      ),
    },
    {
      name: 'Aksi',
      minWidth: '150px',
      cell: (row) => {
        const isExpired = row.expiredDate
          ? new Date() > new Date(row.expiredDate)
          : false

        return (
          <div className="d-flex gap-2">
            <CustomButton
              size="sm"
              onClick={() => {
                if (isExpired) return

                navigate('/public-payment-instruksi', {
                  state: {
                    ...row,
                    ...dataState,
                    token: row?.one_payment_token || token,
                    isVa: false,
                  },
                })
              }}
              disabled={isExpired}
              className={`d-flex align-items-center justify-content-center bg-transparent border-0 p-0 ${isExpired ? 'text-secondary' : 'text-primary'}`}
              style={{ boxShadow: 'none' }}
            >
              <Eye size={20} />
            </CustomButton>
            <CustomButton
              size="sm"
              onClick={() => {
                setSelectedCancelId(row.id)
                setIsCancelModalOpen(true)
              }}
              className="d-flex align-items-center justify-content-center bg-transparent border-0 p-0 text-danger"
              style={{ boxShadow: 'none' }}
            >
              <Trash2 size={20} />
            </CustomButton>
          </div>
        )
      },
    },
  ]

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal)
    setIsClick(false)
  }
  const fetchDisbursementBanks = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/page/tradeshorcut/banks?filter=disbursementtopup`,
        {
          headers: {
            Authorization: `d2hhdHNhcHBXZWJob29rOlBNWFlXQUlTYW5kQm94`,
          },
        },
      )
      setDisbBanks(data?.data ?? [])
    } catch {
      // Error fetching banks
    } finally {
      setLoading(false)
    }
  }

  const fetchContext = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/onepaymentpage/context`,
        {
          params: {
            onepaymentkey: `${token}`,
          },
        },
      )
      if (data?.methodData) {
        if (data?.method === 'BCAVA') {
          if (data?.methodData?.status?.toLowerCase() === 'canceled') {
            if (data?.purpose === 'TOPUP') {
              navigate('/public-payment-failed', {
                state: {
                  ...data,
                },
                replace: true,
              })
            }
          } else if (data?.methodData?.status?.toLowerCase() === 'confirmed') {
            navigate('/public-payment-success', {
              state: {
                ...data,
              },
              replace: true,
            })
          } else {
            navigate('/public-payment-instruksi', {
              state: {
                ...data,
                ...dataState,
                ...data?.methodData,
                bankCodeReceiver: 'BCA',
                isVa: true,
                token: token,
              },
              replace: true,
            })
          }
        } else if (data?.method === 'BRIVA') {
          if (data?.methodData?.status?.toLowerCase() === 'canceled') {
            if (data?.purpose === 'TOPUP') {
              navigate('/public-payment-failed', {
                state: {
                  ...data,
                },
                replace: true,
              })
            }
          } else if (data?.methodData?.status?.toLowerCase() === 'confirmed') {
            navigate('/public-payment-success', {
              state: {
                ...data,
              },
              replace: true,
            })
          } else {
            navigate('/public-payment-instruksi', {
              state: {
                ...data,
                ...dataState,
                ...data?.methodData,
                bankCodeReceiver: 'BRI',
                isVa: true,
                token: token,
              },
              replace: true,
            })
          }
        } else if (data?.method === 'BCAUNIQUECODE') {
          if (data?.methodData?.status?.toLowerCase() === 'canceled') {
            if (data?.purpose === 'TOPUP') {
              navigate('/public-payment-failed', {
                state: {
                  ...data,
                },
                replace: true,
              })
            }
          } else if (data?.methodData?.status?.toLowerCase() === 'confirmed') {
            navigate('/public-payment-success', {
              state: {
                ...data,
              },
              replace: true,
            })
          } else {
            // navigate('/public-payment-instruksi', {
            //   state: {
            //     ...data,
            //     ...dataState,
            //     ...data?.methodData,
            //     token: token,
            //   },
            //   replace: true,
            // })
          }
        } else if (data?.method === 'DURIANPAYDISBURSE') {
          if (
            data?.methodData?.status?.toLowerCase() === 'failed' ||
            data?.methodData?.status?.toLowerCase() === 'canceled'
          ) {
            if (data?.purpose === 'TOPUP') {
              navigate('/public-payment-failed', {
                state: {
                  ...data,
                },
                replace: true,
              })
            }
          } else if (data?.methodData?.status?.toLowerCase() === 'done') {
            navigate('/public-payment-success', {
              state: {
                ...data,
              },
              replace: true,
            })
          } else {
            navigate('/public-payment-instruksi', {
              state: {
                ...data,
                ...dataState,
                ...data?.methodData,
                token: token,
              },
              replace: true,
            })
          }
        }
      }
      setDataUser(data)
    } catch (error) {
      navigate('/public-payment-expired')
    } finally {
      setLoading(false)
    }
  }

  const postBriVa = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topups`,
        {
          customerCode: dataUser?.customerCode,
          amount: displayAmount,
          description: '',
          onepaymentkey: token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${token}`,
        //   },
        // },
      )

      if (data.status?.toLowerCase() === 'pending') {
        navigate('/public-payment-instruksi', {
          state: {
            ...data,
            ...dataState,
            bankCodeReceiver: 'BRI',
            isVa: true,
            token: token,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const postBcaUniqueCode = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topupuniquecode/createmultiple`,
        {
          customerCode: dataUser?.customerCode,
          amount: displayAmount,
          description: '',
        },
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
            OnepaymentKey: `${token}`,
          },
        },
      )

      console.log('Response from createmultiple:', data)

      const status =
        data?.status ||
        data?.data?.status ||
        (Array.isArray(data) && data[0]?.status)
      const responseData = data?.data || (Array.isArray(data) ? data[0] : data)

      if (status?.toLowerCase() === 'pending') {
        navigate('/public-payment-instruksi', {
          state: {
            ...dataState,
            ...responseData,
            token: token,
          },
          replace: true,
        })
      } else {
        // Fallback if status is not 'pending' but we got a response
        setErrMsg('Respons API tidak dikenali: ' + JSON.stringify(data))
      }
    } catch (error) {
      console.error('Error in postBcaUniqueCode:', error)
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const postBcaVa = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topupbca`,
        {
          customerCode: dataUser?.customerCode,
          amount: displayAmount,
          description: '',
          onepaymentkey: token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${token}`,
        //   },
        // },
      )

      if (data.status?.toLowerCase() === 'pending') {
        navigate('/public-payment-instruksi', {
          state: {
            ...data,
            ...dataState,
            bankCodeReceiver: 'BCA',
            isVa: true,
            token: token,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  /* global Durianpay */
  const postDp = async () => {
    try {
      setLoading(true)
      const res = await axios.post(
        `${apiEndpoint}/api/v1/topuppg`,
        {
          amount: displayAmount,
          gateway: 'DURIANPAY-PAYMENTLINK',
          description: '',
          onepaymentkey: token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${token}`,
        //   },
        // },
      )

      if (res) {
        const data = JSON.parse(res?.data?.dumpRequest)?.data
        const script = document.createElement('script')
        script.src = 'https://js.durianpay.id/0.1.48/durianpay.min.js'
        script.async = true
        document.body.appendChild(script)

        script.onload = () => {
          const dpay = Durianpay.init({
            name: 'dpaysdk',
            environment: 'production',
            locale: 'id',
            access_key: data.access_token,
            method: 'getCheckoutButton',

            container_elem: 'pay-btn-container',
            order_info: {
              id: data.id,
              customer_info: {
                id: data.customer_id,
              },
            },
            btn_class_name: 'btn filled',
          })

          dpay.getCheckoutButton()
          document
            .getElementById('dpay-checkout-btn')
            .setAttribute('hidden', 'true')
          document.getElementById('dpay-checkout-btn').click()
        }
      }
    } catch (error) {
      setLoading(false)
      setErrMsg(error?.response?.data?.message ?? error.message)
    }
  }

  const postDpDisbursement = async () => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/topuppg/disbursetopup`,
        {
          bankCode: tfMethod?.code,
          amount: displayAmount,
          onepaymentkey: token,
        },
        // {
        //   headers: {
        //     OnepaymentKey: `${token}`,
        //   },
        // },
      )
      if (data.status?.toLowerCase() === 'processing') {
        navigate('/public-payment-instruksi', {
          state: {
            ...data,
            ...data?.methodData,
            ...dataState,
            token: token,
          },
          replace: true,
        })
        setLoading(false)
      }
    } catch (error) {
      setErrMsg(error?.response?.data?.message ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleLastPick = (e) => {
    localStorage.setItem(
      `lastPickedBank-${dataUser?.userId}`,
      JSON.stringify(e),
    )
  }

  const handleSubmit = async () => {
    console.log(
      'handleSubmit called, topupMethod:',
      topupMethod,
      'tfMethod:',
      tfMethod,
      'selectedPendingBca:',
      selectedPendingBca,
    )
    try {
      if (topupMethod === 'dpVa') {
        await postDp()
      } else if (topupMethod === 'transferDp') {
        if (tfMethod?.code === 'BCA') {
          if (selectedPendingBca) {
            navigate('/public-payment-instruksi', {
              state: {
                ...selectedPendingBca,
                ...dataState,
                token: token,
              },
              replace: true,
            })
          } else {
            await postBcaUniqueCode()
          }
        } else {
          await postDpDisbursement()
        }
      } else if (topupMethod === 'briVa') {
        await postBriVa()
      } else if (topupMethod === 'bcaVa') {
        await postBcaVa()
      } else if (topupMethod === 'mandiriVa') {
        navigate('/public-payment-instruksi', {
          state: {
            ...dataUser,
            ...dataState,
            bankCodeReceiver: 'MANDIRI',
            isVa: true,
            token: token,
          },
          replace: true,
        })
      }
    } catch (error) {
      setErrMsg(error?.data?.message)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    setToken(token)
  }, [])

  useEffect(() => {
    setBanks(
      isClick
        ? disbBanks
        : !isClick && disbBanks.length > 3
          ? disbBanks.slice(0, 4)
          : disbBanks,
    )
  }, [disbBanks, isClick])

  useEffect(() => {
    if (token) {
      fetchContext()
      fetchDisbursementBanks()
    }
  }, [token])

  useEffect(() => {
    fetchPendingBcaPublic()
  }, [fetchPendingBcaPublic])

  useEffect(() => {
    const lastPickedBank =
      JSON.parse(localStorage.getItem(`lastPickedBank-${dataUser?.userId}`)) ||
      []
    if (typeof lastPickedBank !== 'string') {
      // setTopupMethod(lastPickedBank?.method)
      setTfMethod(lastPickedBank)
    } else {
      // setTopupMethod(lastPickedBank)
    }
  }, [dataUser])

  useEffect(() => {
    if (isBcaLocked && disbBanks?.length > 0) {
      const bcaBank = disbBanks.find((e) => e.code === 'BCA')
      if (bcaBank) {
        setTopupMethod('transferDp')
        setTfMethod(bcaBank)
      }
    }
  }, [isBcaLocked, disbBanks])

  if (shouldShowPendingList) {
    const loadingPending = loadingPendingBcaPublic || loadingPendingBcaAll

    return (
      <div
        className="flex-centered"
        style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}
      >
        <Container
          style={{ backgroundColor: 'transparent' }}
          className="custom-container py-5"
        >
          <div
            className="d-flex flex-column gap-3 py-4 px-3 px-md-0 mx-auto"
            style={{ maxWidth: '1100px' }}
          >
            <div className="flex-centered py-2 mb-2">
              <img
                style={{ width: '100%', maxWidth: '200px', height: 'auto' }}
                src={LogoPasmik}
                alt="PasarMIKRO logo"
              />
            </div>
          </div>
          <PMBModalRemove
            isOpen={isCancelModalOpen}
            onClose={() => {
              setIsCancelModalOpen(false)
              setSelectedCancelId(null)
            }}
            onRemoveData={handleCancelTopup}
            title="Batalkan Topup"
            desc="Apakah Anda yakin ingin membatalkan topup ini?"
            buttonRightText="Batalkan Topup"
            dataId={selectedCancelId}
            isLoading={loading}
          />
          <Card
            body
            className="border-0 p-4 p-md-5 mx-auto"
            style={{
              maxWidth: '1100px',
              borderRadius: '20px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
            }}
          >
            <h2
              className="fw-bold mb-5 text-dark"
              style={{ letterSpacing: '-0.5px' }}
            >
              Menunggu Pembayaran
            </h2>

            {errMsg && (
              <div className="mb-3 p-3 bg-white rounded-3 shadow-sm border-start border-danger border-4">
                <small className="text-danger d-flex align-items-center gap-2 fw-500">
                  <AlertCircle size={16} /> {errMsg}
                </small>
              </div>
            )}

            {loadingPending ? (
              <div className="d-flex justify-content-center p-5">
                <Spinner color="primary" />
              </div>
            ) : (
              <DataTable
                columns={pendingBcaColumns}
                data={pendingBcaRows}
                noHeader
                pagination={false}
              />
            )}
          </Card>
          <Card
            body
            className="border-0 p-3 mx-auto mt-3"
            style={{
              maxWidth: '1100px',
              borderRadius: '12px',
              backgroundColor: '#f0f9ff',
              boxShadow: 'none',
            }}
          >
            <div className="d-flex flex-row gap-3 justify-content-between align-items-center">
              <span
                style={{
                  fontSize: '13px',
                  color: '#0056b3',
                  lineHeight: '1.4',
                }}
              >
                Butuh bantuan metode pembayaran lain?
              </span>
              <CustomButton
                onClick={() =>
                  window.open(
                    `https://wa.me/${publicVersion?.data?.csNumber}`,
                    '_blank',
                  )
                }
                color="primary"
                size="sm"
                className="fw-bold px-3 shadow-sm text-nowrap"
                style={{ borderRadius: '8px' }}
              >
                Hubungi Kami
              </CustomButton>
            </div>
          </Card>
        </Container>
      </div>
    )
  }

  return (
    <div
      className="flex-centered"
      style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}
    >
      <Container
        style={{ backgroundColor: 'transparent' }}
        className="custom-container py-3"
      >
        <Modal
          centered
          isOpen={isOpenModal}
          toggle={toggleModal}
          data-testid="payment-method-modal"
        >
          <ModalBody
            style={{ maxHeight: '600px', overflowY: 'auto', padding: '24px' }}
          >
            <h5 className="fw-bold text-dark mb-4">Pilih metode pembayaran</h5>
            <div className="d-flex flex-column gap-2">
              <div className="mb-2">
                <div className="fw-bold text-dark mb-3">Transfer Bank</div>
                {loading ? (
                  <Spinner />
                ) : (
                  <div className="d-flex flex-column gap-2">
                    {banks
                      ?.filter?.((e) => e?.code === 'BCA')
                      ?.map((e, i) => {
                        return (
                          <div key={i} className="mb-2">
                            <div
                              data-testid="payment-method-bca-transfer"
                              style={{
                                backgroundColor:
                                  topupMethod === 'transferDp' &&
                                  tfMethod?.code === e?.code
                                    ? '#F0F9FF'
                                    : '#FFFFFF',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                              }}
                              className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded-3 ${topupMethod === 'transferDp' && tfMethod?.code === e?.code ? 'border-primary shadow-sm' : 'border-light'}`}
                              onClick={() => {
                                setTopupMethod('transferDp')
                                setTfMethod(e)
                                setSelectedPendingBca(null)
                                handleLastPick({ method: 'transferDp', ...e })
                                setErrMsg('')
                                toggleModal()
                              }}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <div
                                  className="p-1 rounded border d-flex align-items-center justify-content-center"
                                  style={{
                                    width: '48px',
                                    height: '48px',
                                    backgroundColor: '#fff',
                                  }}
                                >
                                  <img
                                    style={{
                                      height: 'auto',
                                      width: '100%',
                                      maxHeight: '28px',
                                      objectFit: 'contain',
                                    }}
                                    src={e?.logo}
                                    alt={e?.name}
                                  />
                                </div>
                                <div className="fw-600 text-dark">
                                  Transfer {e?.name}
                                </div>
                              </div>
                              <div
                                style={{
                                  width: '22px',
                                  height: '22px',
                                  borderRadius: '50%',
                                  border:
                                    topupMethod === 'transferDp' &&
                                    tfMethod?.code === e?.code
                                      ? '6px solid #0056b3'
                                      : '2px solid #dee2e6',
                                  transition: 'all 0.2s ease',
                                  backgroundColor: '#fff',
                                }}
                              />
                            </div>
                          </div>
                        )
                      })}
                  </div>
                )}
              </div>
              {!isBcaLocked && (
                <div className="mb-2 mt-2">
                  <div className="fw-bold text-dark mb-3">Virtual Account</div>
                  <div className="d-flex flex-column gap-3">
                    <div
                      data-testid="payment-method-bri-va"
                      style={{
                        backgroundColor:
                          topupMethod === 'briVa' ? '#F0F9FF' : '#FFFFFF',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                      }}
                      className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded-3 ${topupMethod === 'briVa' ? 'border-primary shadow-sm' : 'border-light'}`}
                      onClick={() => {
                        setTopupMethod('briVa')
                        handleLastPick('briVa')
                        toggleModal()
                        setErrMsg('')
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="p-1 rounded border d-flex align-items-center justify-content-center"
                          style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: '#fff',
                          }}
                        >
                          <img
                            style={{
                              height: 'auto',
                              width: '100%',
                              maxHeight: '20px',
                              objectFit: 'contain',
                            }}
                            src={BriLogo}
                            alt="bri"
                          />
                        </div>
                        <div className="fw-600 text-dark">
                          BRI Virtual Account
                        </div>
                      </div>
                      <div
                        style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '50%',
                          border:
                            topupMethod === 'briVa'
                              ? '6px solid #0056b3'
                              : '2px solid #dee2e6',
                          transition: 'all 0.2s ease',
                          backgroundColor: '#fff',
                        }}
                      />
                    </div>
                    <div
                      data-testid="payment-method-bca-va"
                      style={{
                        backgroundColor:
                          topupMethod === 'bcaVa' ? '#F0F9FF' : '#FFFFFF',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                      }}
                      className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded-3 ${topupMethod === 'bcaVa' ? 'border-primary shadow-sm' : 'border-light'}`}
                      onClick={() => {
                        setTopupMethod('bcaVa')
                        handleLastPick('bcaVa')
                        toggleModal()
                        setErrMsg('')
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="p-1 rounded border d-flex align-items-center justify-content-center"
                          style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: '#fff',
                          }}
                        >
                          <img
                            style={{
                              height: 'auto',
                              width: '100%',
                              maxHeight: '20px',
                              objectFit: 'contain',
                            }}
                            src={BcaLogo}
                            alt="bca"
                          />
                        </div>
                        <div className="fw-600 text-dark">
                          BCA Virtual Account
                        </div>
                      </div>
                      <div
                        style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '50%',
                          border:
                            topupMethod === 'bcaVa'
                              ? '6px solid #0056b3'
                              : '2px solid #dee2e6',
                          transition: 'all 0.2s ease',
                          backgroundColor: '#fff',
                        }}
                      />
                    </div>
                    <div
                      data-testid="payment-method-mandiri-va"
                      style={{
                        backgroundColor:
                          topupMethod === 'mandiriVa' ? '#F0F9FF' : '#FFFFFF',
                        cursor:
                          dataUser?.purpose !== 'TOPUP'
                            ? 'not-allowed'
                            : 'pointer',
                        opacity: dataUser?.purpose !== 'TOPUP' ? 0.6 : 1,
                        transition: 'all 0.2s ease',
                      }}
                      className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded-3 ${topupMethod === 'mandiriVa' ? 'border-primary shadow-sm' : 'border-light'}`}
                      onClick={() => {
                        if (dataUser?.purpose === 'TOPUP') {
                          setTopupMethod('mandiriVa')
                          handleLastPick('mandiriVa')
                          toggleModal()
                          setErrMsg('')
                        }
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="p-1 rounded border d-flex align-items-center justify-content-center"
                          style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: '#fff',
                          }}
                        >
                          <img
                            style={{
                              height: 'auto',
                              width: '100%',
                              maxHeight: '24px',
                              objectFit: 'contain',
                            }}
                            src={`${apiEndpoint}/api/v1/publicfile/banks-2-Bank%20Mandiri.jpg`}
                            alt="mandiri"
                          />
                        </div>
                        <div>
                          <div className="fw-600 text-dark">
                            Mandiri Virtual Account
                          </div>
                          {dataUser?.purpose !== 'TOPUP' && (
                            <div
                              className="text-secondary mt-1"
                              style={{ fontSize: '12px' }}
                            >
                              Hanya tersedia untuk opsi Top Up
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '50%',
                          border:
                            topupMethod === 'mandiriVa'
                              ? '6px solid #0056b3'
                              : '2px solid #dee2e6',
                          transition: 'all 0.2s ease',
                          backgroundColor: '#fff',
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {/* <div>
                <p className="fw-500">Pembayaran Lainnya</p>
                <div
                  style={{
                    backgroundColor: topupMethod === 'dpVa' ? '#ECFAFF' : '',
                    cursor: 'pointer',
                  }}
                  className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded ${
                    topupMethod === 'dpVa' ? 'border-primary' : ''
                  }`}
                  onClick={() => {
                    setTopupMethod('dpVa')
                    handleLastPick('dpVa')
                    toggleModal()
                    setErrMsg('')
                  }}
                >
                  <span>Pembayaran Lainnya</span>
                  <Input
                    checked={topupMethod === 'dpVa'}
                    onChange={() => {
                      setTopupMethod('dpVa')
                      handleLastPick('dpVa')
                      toggleModal()
                      setErrMsg('')
                    }}
                    type="radio"
                  />
                </div>
              </div> */}
            </div>
          </ModalBody>
        </Modal>
        <div
          className="d-flex flex-column gap-3 py-4 px-3 px-md-0 mx-auto"
          style={{
            maxWidth: '500px',
            animation: 'fadeIn 0.5s ease',
          }}
        >
          <PMBModalRemove
            isOpen={isCancelModalOpen}
            onClose={() => {
              setIsCancelModalOpen(false)
              setSelectedCancelId(null)
            }}
            onRemoveData={handleCancelTopup}
            title="Batalkan Topup"
            desc="Apakah Anda yakin ingin membatalkan topup ini?"
            buttonRightText="Batalkan Topup"
            dataId={selectedCancelId}
            isLoading={loading}
          />
          <div className="flex-centered py-2 mb-2">
            <img
              style={{ width: '100%', maxWidth: '200px', height: 'auto' }}
              src={LogoPasmik}
              alt="PasarMIKRO logo"
            />
          </div>

          <Card
            body
            className="border-0"
            style={{
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
            }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center py-2">
              <span
                className="text-secondary mb-1"
                style={{ fontSize: '14px', fontWeight: '500' }}
              >
                Total Pembayaran
              </span>
              <span
                data-testid="payment-total-amount"
                className="fw-bold text-dark"
                style={{ fontSize: '28px', letterSpacing: '-0.5px' }}
              >
                <span style={{ fontSize: '20px', marginRight: '4px' }}>Rp</span>
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  intl.formatNumber(displayAmount ?? 0, {
                    useGrouping: 'always',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                )}
              </span>
            </div>
          </Card>

          <Card
            body
            className="border-0 p-4"
            style={{
              borderRadius: '16px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.05)',
            }}
          >
            <h6 className="fw-bold mb-3 text-dark">Metode Pembayaran</h6>
            {isBcaLocked && (
              <div
                className="mb-3 p-3 rounded d-flex gap-2 align-items-start"
                style={{
                  backgroundColor: '#e0f2fe',
                  borderLeft: '4px solid #0284c7',
                }}
              >
                <AlertCircle
                  size={18}
                  className="text-primary mt-1 flex-shrink-0"
                  style={{ color: '#0369a1' }}
                />
                <span
                  style={{
                    fontSize: '13px',
                    color: '#0369a1',
                    lineHeight: '1.4',
                  }}
                >
                  Karena Anda masih memiliki topup BCA yang <b>pending</b>,
                  metode pembayaran saat ini hanya tersedia dengan{' '}
                  <b>Transfer BCA</b>.
                </span>
              </div>
            )}
            <div
              onClick={toggleModal}
              data-testid="payment-method-selector"
              style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                backgroundColor: topupMethod ? '#f8fafc' : '#ffffff',
              }}
              className={`d-flex justify-content-between align-items-center border p-3 rounded-3 mb-1 ${!topupMethod ? 'border-primary' : 'border-light'}`}
            >
              {topupMethod === 'briVa' ? (
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="p-1 rounded border d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      backgroundColor: '#fff',
                    }}
                  >
                    <img
                      style={{
                        height: 'auto',
                        width: '100%',
                        maxHeight: '20px',
                        objectFit: 'contain',
                      }}
                      src={BriLogo}
                      alt="bri"
                    />
                  </div>
                  <div className="fw-600 text-dark">BRI Virtual Account</div>
                </div>
              ) : topupMethod === 'bcaVa' ? (
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="p-1 rounded border d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      backgroundColor: '#fff',
                    }}
                  >
                    <img
                      style={{
                        height: 'auto',
                        width: '100%',
                        maxHeight: '20px',
                        objectFit: 'contain',
                      }}
                      src={BcaLogo}
                      alt="bca"
                    />
                  </div>
                  <div className="fw-600 text-dark">BCA Virtual Account</div>
                </div>
              ) : topupMethod === 'mandiriVa' ? (
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="p-1 rounded border d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      backgroundColor: '#fff',
                    }}
                  >
                    <img
                      style={{
                        height: 'auto',
                        width: '100%',
                        maxHeight: '24px',
                        objectFit: 'contain',
                      }}
                      src={`${apiEndpoint}/api/v1/publicfile/banks-2-Bank%20Mandiri.jpg`}
                      alt="mandiri"
                    />
                  </div>
                  <div className="fw-600 text-dark">
                    Mandiri Virtual Account
                  </div>
                </div>
              ) : topupMethod === 'transferDp' && tfMethod?.code === 'BCA' ? (
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="p-1 rounded border d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      backgroundColor: '#fff',
                    }}
                  >
                    <img
                      style={{
                        height: 'auto',
                        width: '100%',
                        maxHeight: '28px',
                        objectFit: 'contain',
                      }}
                      src={tfMethod?.logo}
                      alt={tfMethod?.name}
                    />
                  </div>
                  <div>
                    <div className="fw-600 text-dark">
                      Transfer {tfMethod?.name}
                    </div>
                    {selectedPendingBca && (
                      <div
                        className="text-secondary"
                        style={{ fontSize: '12px' }}
                      >
                        Melanjutkan topup tertunda
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center gap-3 w-100">
                  <div
                    className="bg-light p-1 rounded border d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      borderStyle: 'dashed !important',
                    }}
                  >
                    <div
                      style={{
                        width: '16px',
                        height: '2px',
                        backgroundColor: '#cbd5e1',
                        borderRadius: '2px',
                      }}
                    />
                  </div>
                  <div
                    className="fw-600 text-secondary"
                    style={{ fontSize: '15px' }}
                  >
                    Pilih metode pembayaran
                  </div>
                </div>
              )}
              <div className="bg-white rounded-circle shadow-sm p-1 d-flex">
                <ChevronRight size={18} className="text-primary" />
              </div>
            </div>
          </Card>

          <Card
            body
            className="border-0 p-3"
            style={{
              borderRadius: '12px',
              backgroundColor: '#f0f9ff',
              boxShadow: 'none',
            }}
          >
            <div className="d-flex flex-row gap-3 justify-content-between align-items-center">
              <span
                style={{
                  fontSize: '13px',
                  color: '#0056b3',
                  lineHeight: '1.4',
                }}
              >
                Butuh bantuan metode pembayaran lain?
              </span>
              <CustomButton
                testId="payment-contact-cs-button"
                onClick={() =>
                  window.open(
                    `https://wa.me/${publicVersion?.data?.csNumber}`,
                    '_blank',
                  )
                }
                color="primary"
                size="sm"
                className="fw-bold px-3 shadow-sm text-nowrap"
                style={{ borderRadius: '8px' }}
              >
                Hubungi Kami
              </CustomButton>
            </div>
          </Card>

          {errMsg && (
            <div
              data-testid="payment-error-message"
              className="p-3 bg-white rounded-3 shadow-sm border-start border-danger border-4"
            >
              <small className="text-danger d-flex align-items-center gap-2 fw-500">
                <AlertCircle size={16} /> {errMsg}
              </small>
            </div>
          )}

          <div className="mt-2 mb-5">
            <CustomButton
              testId="payment-pay-now-button"
              onClick={() => handleSubmit()}
              disabled={loading || !topupMethod}
              color="primary"
              block
              className="py-3 fw-bold shadow-sm"
              style={{
                borderRadius: '14px',
                fontSize: '16px',
                background:
                  loading || !topupMethod
                    ? '#e2e8f0'
                    : 'linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)',
                border: 'none',
                transition: 'all 0.2s ease',
                transform:
                  loading || !topupMethod ? 'none' : 'translateY(-2px)',
              }}
            >
              Bayar Sekarang
            </CustomButton>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default OneLinkTopup
